import React from "react";
import Button from "@material-ui/core/Button";
import styled from "styled-components";
import AddIcon from "@material-ui/icons/Add";
const StyledSecondaryButton = styled(Button)`
  &.MuiButton-root {
    background: transparent;
    color: #16191f;
    font-size: 13px;
    line-height: 18px;
    border-radius: 4px;
    height: 36px;
    font-weight: 800;
    border: 1px solid #16191f;
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0px 10px;
    &:hover {
      background: #f8fbff;
    }
  }
`;

const OutlineButton = ({ children, showIcon, ...rest }) => {
  return <StyledSecondaryButton {...rest}>{children}</StyledSecondaryButton>;
};

export default OutlineButton;
